import Cookie from 'js-cookie'
import store from '~store'

export const setToken = ({ token, token_expired_at, type }) => {
  const expires = new Date(token_expired_at)
  const config = {
    secure: true,
    expires,
    domain: window.location.hostname,
    sameSite: 'lax'
  }

  Cookie.set('ntust-career', token, config)
  Cookie.set('ntust-career-expires', expires, config)
  Cookie.set('ntust-career-type', type, config)
}

export const unsetToken = ({ type }) => {
  const config = {
    domain: window.location.hostname
  }
  Cookie.remove('ntust-career', config)
  Cookie.remove('ntust-career-expires', config)
  Cookie.remove('ntust-career-type', config)
}

export const getToken = () => {
  const isAuthenticated = store.getters['auth/isAuthenticatedGetter']
  if (!isAuthenticated) {
    const token = Cookie.get('ntust-career')
    if (token) {
      const expires = Cookie.get('ntust-career-expires')
      const type = Cookie.get('ntust-career-type')

      store.commit('auth/setCurrentUser', {
        response: {
          token,
          token_expired_at: expires
        },
        type
      })
    }
  }
}
